import { __decorate, __metadata } from "tslib";
import { IdvSkippedReason, KYCResultResponse, } from '@cbbt/itf-unverified-individual-customer-domain';
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { Address } from './Address.js';
import { NationalityAndTaxResidentRequest } from './NationalityAndTaxResidentRequest.js';
import { PersonalDetails } from './PersonalDetails.js';
export class GetIdvIndividualResponse extends BaseMessage {
    individualId;
    caseRefNumber;
    processCode;
    guid;
    retryCount;
    identityVerificationSkipped;
    identityVerificationSkippedReason;
    personalDetails;
    addresses;
    nationalities;
    kycResult;
}
__decorate([
    Field.string({
        required: true,
        description: 'individualId',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], GetIdvIndividualResponse.prototype, "individualId", void 0);
__decorate([
    Field.string({
        required: true,
        description: 'Case Reference Number',
        maxLength: 40,
    }),
    __metadata("design:type", String)
], GetIdvIndividualResponse.prototype, "caseRefNumber", void 0);
__decorate([
    Field.string({
        required: true,
        description: 'Process Code',
    }),
    __metadata("design:type", String)
], GetIdvIndividualResponse.prototype, "processCode", void 0);
__decorate([
    Field.string({
        required: true,
        description: 'guid',
    }),
    __metadata("design:type", String)
], GetIdvIndividualResponse.prototype, "guid", void 0);
__decorate([
    Field.number({
        required: true,
        description: 'retryCount',
        numberType: 'integer',
    }),
    __metadata("design:type", Number)
], GetIdvIndividualResponse.prototype, "retryCount", void 0);
__decorate([
    Field.boolean({
        required: true,
        description: 'idv skipped flag',
    }),
    __metadata("design:type", Boolean)
], GetIdvIndividualResponse.prototype, "identityVerificationSkipped", void 0);
__decorate([
    Field.enum({
        enum: IdvSkippedReason,
        required: true,
        description: 'reason for skipping idv',
    }),
    __metadata("design:type", String)
], GetIdvIndividualResponse.prototype, "identityVerificationSkippedReason", void 0);
__decorate([
    Field.message({
        description: 'Personal Details of an Individual',
        required: true,
    }),
    __metadata("design:type", PersonalDetails)
], GetIdvIndividualResponse.prototype, "personalDetails", void 0);
__decorate([
    Field.message({
        description: 'Address',
        required: true,
    }),
    __metadata("design:type", Address)
], GetIdvIndividualResponse.prototype, "addresses", void 0);
__decorate([
    Field.message({
        description: 'Nationality',
        required: true,
    }),
    __metadata("design:type", NationalityAndTaxResidentRequest)
], GetIdvIndividualResponse.prototype, "nationalities", void 0);
__decorate([
    Field.array({
        required: true,
        items: {
            type: 'message',
            message: KYCResultResponse,
        },
    }),
    __metadata("design:type", Array)
], GetIdvIndividualResponse.prototype, "kycResult", void 0);
//# sourceMappingURL=GetIdvIndividualResponse.js.map